"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Dr. Sarah Jenkins",
  title: "Lead Veterinarian",
  bio: "Fun Fact: Sarah once rescued a baby squirrel during a hiking trip and successfully rehabilitated it!",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/vet_sarah_dog.png"
}, {
  name: "Dr. Michael Chen",
  title: "Surgical Specialist",
  bio: "Fun Fact: Michael has a collection of over fifty vintage bowties that he wears for his feline patients.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/vet_michael_cat.png"
}, {
  name: "Emily Rodriguez",
  title: "Head Veterinary Tech",
  bio: "Fun Fact: Emily speaks three languages and uses them to calm nervous pets from all backgrounds.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/tech_emily_rabbit.png"
}];
export default function MeetYourPetSCaregivers() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="229804" id="meet-your-pets-caregivers" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-12 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Meet Your Pet's Caregivers
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl">
            A dedicated team of animal lovers committed to providing the highest standard of compassionate care.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {teamMembers.map((member, i) => <Card key={i} data-index={i} className="group overflow-hidden rounded-3xl shadow-md border border-border bg-card transition-all duration-500 hover:shadow-xl">
              <AspectRatio ratio={1}>
                <img src={member.image} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105" />
              </AspectRatio>
              <CardContent className="p-8">
                <h3 className="font-default text-2xl font-semibold text-foreground">
                  {member.name}
                </h3>
                <div className="inline-block bg-accent text-accent-foreground px-3 py-1 rounded-md text-xs font-bold uppercase tracking-wider mt-2 mb-4">
                  {member.title}
                </div>
                <p className="font-default text-base text-foreground leading-relaxed italic opacity-90">
                  {member.bio}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}